import { InitProductTabs } from './helpers';

export default () => {
  if (!document.getElementById('shopify-section-product-tabs')) {
    return false;
  }

  const selectors = {
    $container: document.getElementById('shopify-section-product-tabs'),
    $innerContainer: document.querySelector('.product-tabs__inner'),
    $items: document.querySelectorAll('.product-tabs__item'),
    $activeContentPanel: document.querySelector(
      '.product-tabs__item-panel.active'
    ),
  };
  InitProductTabs(selectors);
};
